import { message } from "antd";
import { useEffect } from "react";

const CheckSection = ({
  title,
  fields,
  dataObject,
  setDataObject,
  rootObj,
  type,
}) => {

  // console.log(title,
  //   fields,
  //   dataObject,
  //   type,"checksectionprops");

  // Sync dataObject with fields whenever fields change
  useEffect(() => {
    setDataObject((prev) => {
      const updated = {};
      let changed = false;
      fields.forEach((field) => {
        updated[field.name] = prev.hasOwnProperty(field.name)
          ? prev[field.name]
          : false;
        if (!prev.hasOwnProperty(field.name)) changed = true;
      });
      // Only update if something actually changed
      if (changed || Object.keys(prev).length !== fields.length) {
        return updated;
      }
      return prev;
    });
  }, [fields, setDataObject]);

  // fidelio_code and revenue_center are mutually exclusive per category -
  // only enforced when turning one ON while the other is already ON
  const FIDELIO_REVENUE_LABEL = {
    fidelio_code: "Fidelio Code",
    revenue_center: "Revenue Center",
  };

  const handleCheckboxChange = (name) => {
    if (name === "venue" || name === "deck_location") {
      if (type === "venue") {
        message.error("Cannot Select " + name + " your already selected Venue in Primary Selection");
        return;
      }
    } else if (name === "fidelio_code" || name === "revenue_center") {
      const other = name === "fidelio_code" ? "revenue_center" : "fidelio_code";
      // check both this section (Static/Dynamic) and the other section
      // (rootObj) - this is a category-wide condition, not per-section
      if (!dataObject[name] && (dataObject[other] || rootObj?.[other])) {
        message.error(
          `Cannot select ${FIDELIO_REVENUE_LABEL[name]} - ${FIDELIO_REVENUE_LABEL[other]} is already selected for this category`
        );
        return;
      }
    }

    setDataObject((prev) => ({
      ...prev,
      [name]: !prev[name], // toggle true/false
    }));
  };

  return (
    <div className="fieldrow">
      {title && (
        <label className="f_label" style={{ marginBottom: "10px" }}>
          {title}
        </label>
      )}

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gap: "12px",
        }}
      >
        {fields.map((field) =>
          rootObj[field.name] ? (
            <></>
          ) : (
            <label
              key={field.name}
              style={{
                border: "1px solid #ccc",
                padding: "8px",
                borderRadius: "6px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <input
                type="checkbox"
                checked={!!dataObject[field.name]}
                onChange={() => handleCheckboxChange(field.name)}
              />
              {field.title}
            </label>
          )
        )}
      </div>
    </div>
  );
};

export default CheckSection;
